import { AnalyticsDocumentSetItem } from "./analytics-document-set-item";

export class AnalyticsDocumentSetPerson {
  organizationalUnitId: number;
  firstName: string;
  lastName: string;
  mail: string;
  cuil: string;
  percentage: number;
  finishedDocuments: number;
  totalDocuments: number;
  userId: string;
  documents: AnalyticsDocumentSetItem[];
  selected:boolean;
  disabled:boolean;
  constructor() {}
}
